import { SxProps } from '@mui/material';

export const ContainerSx: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
};

export const LinkSx = (bold?: boolean, underlined?: boolean): SxProps => ({
  color: '#000000',
  textDecoration: underlined ? 'underline' : 'none',
  fontWeight: bold ? 'bold' : 'normal',
  '&:hover': {
    color: '#000000',
    textDecoration: 'underline',
  },
}); 
